const MILLISECONDS_PER_SECOND = 1e3;
export {
  MILLISECONDS_PER_SECOND
};
//# sourceMappingURL=constants.time.js.map
